/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../components/finalForms/FormCreator";

import { removeFormFields, setFieldSetting } from "../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../components/finalForms/libs/data/fieldSettingType";

/** css file */
import "../../../../Contracts.scss"

/** Utilities */
import { setDropdownOptions } from "../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import CoverageCounts from "./features/CoverageCounts";
import DeferralPeriods from "./features/DeferralPeriods";

/** Configuration files */
import { specificationsConfig } from "./Specifications.formfield.config";

/** RTK Query */
import { useGetAllSalesrepsMutation, useGetAllsalesTaxMutation, useLazyGetAllContractInstallmentTypesQuery, useLazyGetAllContractServicePlanTermsQuery, useLazyGetAllContractTypeQuery, useUpdateSharedRiskDateMutation } from "../../../../../../app/services/contractAPI";
import { useLazyGetAllPaymentTermsQuery } from "../../../../../../app/services/commonAPI";
import { ContractContext } from "../../../../../../utils/context/ContractContext";

const Specifications = (props,ref) => {

  const { contractData, contractId } = useContext(ContractContext);
  const filteredForm = removeFormFields(specificationsConfig, ['bServicePlan', 'lServicePlanTermKey'])
  const [specificationForm, setSpecificationForm] = useState(filteredForm);
  const SpecificationsRef = useRef();
  const [isUnlimitedProducts, setIsUnlimitedProducts] = useState(false);

  const [getAllContractType, {
    isSuccess: isAllContractTypeFetched,
    data: AllContractTypeData
  }] = useLazyGetAllContractTypeQuery();


  const [getAllSalesreps, {
    isSuccess: isAllSalesrepsFetched,
    data: AllSalesrepsData
  }] = useGetAllSalesrepsMutation();

  const [getAllPaymentTerms, {
    isFetching: isPayTermsFetching,
    isSuccess: isPayTermsFetched,
    data: payTermsData,
  },] = useLazyGetAllPaymentTermsQuery();

  const [getAllContractServicePlanTerms, {
    isFetching: isAllContractServicePlanTermsFetching,
    isSuccess: isAllContractServicePlanTermsFetched,
    data: AllContractServicePlanTermsData,
  }] = useLazyGetAllContractServicePlanTermsQuery();

  const [getAllsalesTax, {
    isSuccess: isAllsalesTaxFetched,
    data: AllsalesTaxData
  }] = useGetAllsalesTaxMutation();

  const [getAllContractInstallmentTypes, {
    isFetching: isAllContractInstallmentTypesFetching,
    isSuccess: isAllContractInstallmentTypesFetched,
    data: allContractInstallmentTypesData,
  },] = useLazyGetAllContractInstallmentTypesQuery();

  const [updateSharedRiskDate, {
    isSuccess: isupdateSharedRiskDateUpdated,
    data: updateSharedRiskDateData,
  },] = useUpdateSharedRiskDateMutation();


  useEffect(() => {
    resetForm();
    getAllContractType(false);
    getAllContractInstallmentTypes(true);
    const SaleTaxreq = { pbIncludeNone: true, pbIncludeInactive: true }
    getAllsalesTax(SaleTaxreq);
    const SalesrepReq = { pbIncludeBlank: false, psActiveFlag: 'Y' }
    getAllSalesreps(SalesrepReq);
    getAllPaymentTerms();
    setFieldSetting(specificationForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, true);
    setFieldSetting(specificationForm, 'lInstallmentTypeID', FieldSettingType.ISFIELDDATALOADING, true);
    setFieldSetting(specificationForm, 'lSalesRepKey', FieldSettingType.ISFIELDDATALOADING, true);
    setFieldSetting(specificationForm, 'lSalesTaxKey', FieldSettingType.ISFIELDDATALOADING, true);
    setFieldSetting(specificationForm, "lPaymentTermsKey", FieldSettingType.ISFIELDDATALOADING, true);
  }, [contractId])

  useEffect(() => {
    if (!isAllContractServicePlanTermsFetching && isAllContractServicePlanTermsFetched && AllContractServicePlanTermsData) {
      setDropdownOptions(AllContractServicePlanTermsData, 'lServicePlanTermKey', 'sServicePlanTerm', specificationForm, 'lServicePlanTermKey', setSpecificationForm);
      setFieldSetting(specificationForm, 'lServicePlanTermKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllContractServicePlanTermsFetching, isAllContractServicePlanTermsFetched, AllContractServicePlanTermsData])

  useEffect(() => {
    if (isAllSalesrepsFetched && AllSalesrepsData) {
      setDropdownOptions(AllSalesrepsData, 'lSalesRepKey', 'repName', specificationForm, 'lSalesRepKey', setSpecificationForm);
      setFieldSetting(specificationForm, 'lSalesRepKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllSalesrepsFetched, AllSalesrepsData])

  useEffect(() => {
    if (isAllsalesTaxFetched && AllsalesTaxData) {
      setDropdownOptions(AllsalesTaxData, 'lSalesTaxKey', 'sSalesTaxName', specificationForm, 'lSalesTaxKey', setSpecificationForm);
      setFieldSetting(specificationForm, 'lSalesTaxKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllsalesTaxFetched, AllsalesTaxData])

  useEffect(() => {
    if (!isAllContractInstallmentTypesFetching && isAllContractInstallmentTypesFetched && allContractInstallmentTypesData) {
      setDropdownOptions(allContractInstallmentTypesData, 'lInstallmentTypeID', 'sInstallmentType', specificationForm, 'lInstallmentTypeID', setSpecificationForm);
      setFieldSetting(specificationForm, 'lInstallmentTypeID', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllContractInstallmentTypesFetching, isAllContractInstallmentTypesFetched, allContractInstallmentTypesData])

  useEffect(() => {
    if (!isPayTermsFetching && isPayTermsFetched && payTermsData) {
      setDropdownOptions(payTermsData, "lPaymentTermsKey", "sTermsDesc", specificationForm, "lPaymentTermsKey", setSpecificationForm);
      setFieldSetting(specificationForm, "lPaymentTermsKey", FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isPayTermsFetching, isPayTermsFetched, payTermsData]);

  useEffect(() => {
    if (isAllContractTypeFetched && AllContractTypeData) {
      setDropdownOptions(AllContractTypeData, 'lContractTypeKey', 'sContractType', specificationForm, 'lContractTypeKey', setSpecificationForm);
      setFieldSetting(specificationForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllContractTypeFetched, AllContractTypeData])

  useEffect(() => {
    if (isupdateSharedRiskDateUpdated && updateSharedRiskDateData) {
      if (updateSharedRiskDateData?.dtSharedRiskStartDate !== "0001-01-01T00:00:00") {
        let formData = { ...specificationForm };
        formData.initialState = {
          ...formData.initialState,
          dtSharedRiskStartDate: updateSharedRiskDateData?.dtSharedRiskStartDate ? new Date(updateSharedRiskDateData?.dtSharedRiskStartDate) : null,
        };
        setSpecificationForm(formData);
      }
    }
  }, [isupdateSharedRiskDateUpdated, updateSharedRiskDateData])

  useEffect(() => {
    if (contractData) {
      setIsUnlimitedProducts(contractData?.bUnlimitedProducts);
      let formData = { ...specificationForm };
      formData.initialState = {
        dtDateEffective: new Date(contractData?.dtDateEffective),
        dtOriginalTerminationDate: contractData?.dtOriginalTerminationDate ? new Date(contractData?.dtOriginalTerminationDate) : null,
        dtDateTermination: new Date(contractData?.dtDateTermination),
        lContractTypeKey: contractData?.lContractTypeKey,
        lSalesRepKey: contractData?.lSalesRepKey,
        lSalesTaxKey: contractData?.lSalesTaxKey,
        lPaymentTermsKey: contractData?.lPaymentTermsKey,
        lInstallmentTypeID: contractData?.lInstallmentTypeID,
        lServicePlanTermKey: contractData?.lServicePlanTermKey,
        bTaxExempt: contractData?.bTaxExempt,
        sPurchaseOrder: contractData?.sContractNumber,
        bUnlimitedProducts: contractData?.bUnlimitedProducts,
        pbShowConsumptionOnPortal: contractData?.bShowConsumptionOnPortal,
        bCostsPerDepartment: contractData?.bCostsPerDepartment,
        dblAmtInvoiced: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', }).format(contractData?.dblAmtInvoiced),
        dblAmtTotal: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', }).format(contractData?.dblAmtTotal),
        bManualSchedule: contractData?.bManualSchedule,
        dblContractDepartmentTotal: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', }).format(contractData?.dblContractDepartmentTotal),
        dblContractBillScheduleToatl: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', }).format(contractData?.dblContractBillScheduleToatl),
        sRenewedContract: contractData?.sRenewedContract,
        bServicePlan: contractData?.bServicePlan,
        bSharedRisk: contractData?.bSharedRisk,
        nSharedRiskPercentage: contractData?.nSharedRiskPercentage,
        dtSharedRiskStartDate: contractData?.dtSharedRiskStartDate ? new Date(contractData?.dtSharedRiskStartDate) : null,
      };
      setFieldSetting(formData, "nSharedRiskPercentage", FieldSettingType.DISABLED, !formData.initialState.bSharedRisk);
      setFieldSetting(formData, "lSalesTaxKey", FieldSettingType.DISABLED, formData.initialState.bTaxExempt);
      setFieldSetting(formData, "bUnlimitedProducts", FieldSettingType.DISABLED, formData.initialState.bUnlimitedProducts);
      setFieldSetting(formData, "dtDateTermination", FieldSettingType.DISABLED, false);
      if (formData.initialState.lContractTypeKey === 1) {
        if (formData.initialState.bServicePlan === true) {
          getAllContractServicePlanTerms(true);
          setSpecificationForm({
            ...specificationsConfig,
            initialState: formData.initialState || {},
          });
        }
        else {
          const FilterFormFields = removeFormFields(specificationsConfig, ['lServicePlanTermKey']);
          setSpecificationForm({
            ...FilterFormFields,
            initialState: formData.initialState || {},
          });
        }
      }

      else {
        setSpecificationForm(formData);
      }
    }
  }, [contractData]);

  const handleColumnChange = (dataField, updatedData) => {
    if (dataField === 'bUnlimitedProducts') {
      setIsUnlimitedProducts(updatedData?.bUnlimitedProducts);
    }
    else if (dataField === 'bSharedRisk') {
      setFieldSetting(specificationForm, "nSharedRiskPercentage", FieldSettingType.DISABLED, !updatedData.bSharedRisk);
      if (updatedData?.bSharedRisk === false) {
        setSpecificationForm({
          ...specificationForm,
          initialState: {
            ...specificationForm.initialState,
            nSharedRiskPercentage: null,
            bSharedRisk: false,
          },
        })
      }
    }
    else if (dataField === 'bTaxExempt') {
      setFieldSetting(specificationForm, "lSalesTaxKey", FieldSettingType.DISABLED, updatedData.bTaxExempt);
        setSpecificationForm({
          ...specificationForm,
          initialState: {
            ...specificationForm.initialState,
            lSalesTaxKey: null,
            bTaxExempt: updatedData?.bTaxExempt,
          },
        })
    }
    else if (dataField === 'lContractTypeKey') {
      handleFiledShowHide(dataField, updatedData);
    }
    else if (dataField === 'bServicePlan') {
      handleFiledShowHide(dataField, updatedData);
      getAllContractServicePlanTerms(true);
      setFieldSetting(specificationForm, "dtDateTermination", FieldSettingType.DISABLED, updatedData.bServicePlan);
    }
    else if (dataField === 'lServicePlanTermKey') {
      const label = updatedData?.lServicePlanTermKey?.label || "";
      const monthsMatch = label.match(/\d+/);
      const months = monthsMatch ? parseInt(monthsMatch[0], 10) : 0;
      const newTerminationDate = new Date(updatedData.dtDateEffective);
      newTerminationDate.setMonth(updatedData.dtDateEffective.getMonth() + months);
      newTerminationDate.setDate(newTerminationDate.getDate() - 1);
      setSpecificationForm({
        ...specificationForm,
        initialState: {
          ...specificationForm.initialState,
          dtDateTermination: newTerminationDate,
          lServicePlanTermKey: updatedData?.lServicePlanTermKey,
          lContractTypeKey: 1,
          bServicePlan: true,
        }
      });
    }
  }

  const handleFiledShowHide = (dataField, updatedData) => {
    if (dataField === 'lContractTypeKey') {
      setSpecificationForm((prevForm) => {

        const currentInitialState = prevForm.initialState || {};

        if (updatedData?.lContractTypeKey?.label === 'CPO') {
          if (updatedData?.bServicePlan === true) {
            return {
              ...specificationsConfig,
              initialState: currentInitialState,
            };
          }
          const formConfig = { ...specificationsConfig };
          const FilterFormFields = removeFormFields(formConfig, ['lServicePlanTermKey']);
          return {
            ...FilterFormFields,
            initialState: currentInitialState,
          };
        }
        else {
          return {
            ...filteredForm,
            initialState: currentInitialState,
          };
        }
      });
    }
    else if (dataField === 'bServicePlan') {
      if (updatedData?.bServicePlan === true) {
        setSpecificationForm((prevForm) => {
          return {
            ...specificationsConfig,
            initialState: prevForm.initialState || {},
          };
        });
      } else {

        setSpecificationForm((prevForm) => {
          const formConfig = { ...specificationsConfig };
          const FilterFormFields = removeFormFields(formConfig, ['lServicePlanTermKey']);
          return {
            ...FilterFormFields,
            initialState: prevForm.initialState || {},
          };
        });
      }
    }
  };

  const handleFiledBlure = (dataField, updatedData) => {
    if (dataField === 'nSharedRiskPercentage') {
      if (updatedData?.nSharedRiskPercentage) {
        const req = {
          plContractKey: contractId,
          pbForceSharedRisk: true,
          pbOverridePercentage: true,
          pbSave: false,
          pnSharedRiskPercentage: updatedData?.nSharedRiskPercentage
        };
        updateSharedRiskDate(req);
      }
    }
  };

  const resetForm = () => {
    const form = { ...specificationForm };
    form.initialState = { ...specificationForm.initialState }
    setSpecificationForm(form);
  };

  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        const ContractFormData = SpecificationsRef.current.getFormDataWithoutValidation();
        if (ContractFormData) {
          return { ...ContractFormData };
        }
      }
      return null;
    },
  }));

  return (
    <>
      <div className="row">
        <FormCreator
          ref={SpecificationsRef}
          config={specificationForm}
          onColumnChange={handleColumnChange}
          onFieldBlure={handleFiledBlure}
        />
      </div>
      <div className="row">
        <div className="col-6 left-grid">
          <DeferralPeriods contractId={contractId} />
        </div>
        <div className="col-6 right-grid">
          <CoverageCounts contractId={contractId}
            isUnlimitedProducts={isUnlimitedProducts}
          />
        </div>
      </div>

    </>
  );
};
export default forwardRef(Specifications);
